import { IBrandOrder } from "@faire/web-api--source/indigofair/data/IBrandOrder";
import { ISelfServeContextShippingResponse } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeContextShippingResponse";
import React from "react";

import { SOYOProcessing } from "./updateTrackingInfo/SOYOProcessing";
import { SOYOShipped } from "./updateTrackingInfo/SOYOShipped";
import { SWFProcessing } from "./updateTrackingInfo/SWFProcessing";
import { SWFShipped } from "./updateTrackingInfo/SWFShipped";

interface IUpdateTrackingInfoProps {
  shippingContext: ISelfServeContextShippingResponse;
  isSwf?: boolean;
}

export const UpdateTrackingInfoIA: React.FC<IUpdateTrackingInfoProps> = ({
  shippingContext,
  isSwf,
}) => {
  const orderState = shippingContext.state;
  if (!isSwf && orderState === IBrandOrder.State.PROCESSING) {
    return <SOYOProcessing />;
  } else if (isSwf && orderState === IBrandOrder.State.PROCESSING) {
    return <SWFProcessing />;
  } else if (!isSwf && orderState === IBrandOrder.State.SHIPPED) {
    return <SOYOShipped />;
  } else if (isSwf && orderState === IBrandOrder.State.SHIPPED) {
    return <SWFShipped />;
  }
  return null;
};
